export default {
  computed: {
    buttonText () {
      const { productPendingStock } = this.productCodeData
      const availablePendingStock = Number(productPendingStock) - Number(this.cartQuantity)
      const availableStock = Number(this.stock) - Number(this.cartQuantity)
      const firstEditionDate = this.productMetaData?.firstEditionDate ? new Date(this.productMetaData.firstEditionDate) : null

      // if the first edition date is in the future
      if (firstEditionDate && firstEditionDate > new Date()) {
        return this.t('product_status.preorder')
      }

      // if there is no stock and there is pending stock
      if (availableStock < 1 && availablePendingStock > 0) {
        const { availableFrom, availableUntil } = this.productData

        const currentDate = new Date()
        const availableFromDate = availableFrom ? new Date(availableFrom) : null
        const availableUntilDate = availableUntil ? new Date(availableUntil) : null

        // if firstEditionDate is in the past
        if (firstEditionDate && firstEditionDate < new Date()) {
          return this.t('product_status.preorder')
        }

        // if availableUntil is set and the current date is greater than the availableUntil date, return unavailable
        if (availableUntilDate && currentDate > availableUntilDate) {
          return this.t('product_status.unavailable.text')
        }

        // if product has pending stock and availableFromDate is set
        if (availableFromDate && productPendingStock > 0 && !this.cartLimitReached) {
          return this.t('product_status.preorder')
        }

        return this.t('product_status.preorder')
      }

      if (this.isVariationGroupMaster && this.isListing) {
        return this.t('product_status.select.variation')
      }

      if (!this.available && !this.cartLimitReached) {
        return this.t('product_status.unavailable.coming_soon')
      }

      if (this.cartLimitReached) {
        return this.t('product_status.unavailable.text')
      }

      if (!this.available && this.hasAttributes && !this.selectedAttributeId) {
        return this.t('product_status.unavailable.choose_attr')
      }

      if (this.progress) {
        return `${this.t('product_status.progress')}...`
      }

      if (!this.onlineStatus) {
        return `<i class="icon-energy icons"></i>${this.t('online_status.offline')}`
      }

      if (this.productData?.isDigital) {
        return this.t('add_to_cart_ebook')
      }

      return this.t('add_to_cart_book')
    },
    disabled () {
      return this.quantity < 1 || !this.onlineStatus || !this.available || this.progress || this.cartLimitReached
    },
    available () {
      return (this.stock > 0 || this.isPreorderProduct) && !this.unavailable
    },
    isPreorderProduct () {
      const { productPendingStock } = this.productCodeData
      const { availableFrom, availableUntil } = this.productData
      const availablePendingStock = Number(productPendingStock) - Number(this.cartQuantity)
      const availableStock = Number(this.stock) - Number(this.cartQuantity)

      const firstEditionDate = this.productMetaData?.firstEditionDate ? new Date(this.productMetaData.firstEditionDate) : null

      // if the first edition date is in the future
      if (firstEditionDate && firstEditionDate > new Date()) {
        return true
      }

      // if there is no stock and there is available stock and the first edition date is in the past
      if ((availableStock < 1 && availablePendingStock > 0) && (firstEditionDate && firstEditionDate < new Date())) {
        return true
      }

      const currentDate = new Date()
      const availableFromDate = availableFrom ? new Date(availableFrom) : null
      const availableUntilDate = availableUntil ? new Date(availableUntil) : null

      // if availableUntil is set and the current date is greater than the availableUntil date, return false
      if (availableUntilDate && currentDate > availableUntilDate) {
        return false
      }

      // if product has pending stock and availableFromDate is set
      return !!(productPendingStock > 0 && availableFromDate)
    },
    isProductInAvailabilityDate () {
      const { availableFrom, availableUntil } = this.productData
      if (availableFrom || availableUntil) {
        const currentDate = Date.now()
        return (
          (availableFrom != null && currentDate < new Date(availableFrom).getTime()) ||
          (availableUntil != null && currentDate > new Date(availableUntil).getTime())
        )
      }
      return false
    }
  }
}
